import { useState } from 'react';
import { Icons } from './Icons';
import { LINKS } from '../constants';
import { useInView } from '../hooks';
import styles from './Community.module.css';

function CommCard({ href, icon: IconComp, title, sub, accent, delay, inView }) {
  const [hov, setHov] = useState(false);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.card}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        borderColor: hov ? accent : 'rgba(255,255,255,0.07)',
        background: hov ? 'rgba(20,20,35,0.9)' : 'rgba(13,13,22,0.8)',
        transform: hov ? 'translateY(-2px)' : 'none',
        boxShadow: hov ? `0 8px 32px rgba(59,130,246,0.12)` : 'none',
        opacity: inView ? 1 : 0,
        transition: `border-color 0.2s, background 0.2s, transform 0.2s, box-shadow 0.2s, opacity 0.5s ease ${delay}s`,
      }}
    >
      <div className={styles.iconWrap} style={{ background: `${accent}18`, color: accent }}>
        <IconComp />
      </div>
      <div>
        <div className={styles.cardTitle}>{title}</div>
        <div className={styles.cardSub}>{sub}</div>
      </div>
    </a>
  );
}

export default function Community({ t }) {
  const [ref, inView] = useInView(0.1);

  const cards = [
    { href: LINKS.channel, icon: Icons.Telegram, title: t.card1Title, sub: t.card1Sub, accent: '#3B82F6', delay: 0    },
    { href: LINKS.chat,    icon: Icons.Telegram, title: t.card2Title, sub: t.card2Sub, accent: '#06B6D4', delay: 0.1  },
    { href: LINKS.dex,     icon: Icons.Chart,    title: t.card3Title, sub: t.card3Sub, accent: '#3B82F6', delay: 0.2  },
    { href: LINKS.buy,     icon: Icons.Arrow,    title: t.card4Title, sub: t.card4Sub, accent: '#06B6D4', delay: 0.3  },
  ];

  return (
    <section className={styles.section} id="community">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>
        </div>

        <div className={styles.grid}>
          {cards.map(c => <CommCard key={c.href} {...c} inView={inView} />)}
        </div>
      </div>
    </section>
  );
}
